var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"p-10 bg-transparent"},[_c('img',{staticClass:"w-32 mx-auto block",attrs:{"src":require("@/assets/images/misc/emptyfilter.png")}}),_c('h5',{staticClass:"text-center my-4"},[_vm._v("No results for these filters")])])
}
var staticRenderFns = []

export { render, staticRenderFns }